import { Button } from "react-bootstrap";
import styled, { createGlobalStyle } from "styled-components";

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 96px 16px;
    }
  }
`;

export const TabsWrapper = styled.div`
  margin-right: 16px;

  @media (max-width: 768px) {
    ul.nav-tabs {
      top: 168px;
    }
  }
`;

export const NavigationRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  margin-right: 16px;
`;

export const HeaderContainer = styled.div`
  padding-bottom: 32px !important;
  padding-top: 10px;

  background-color: var(--background) !important;

  position: sticky;
  top: 80px;
  z-index: 99;

  @media (max-width: 768px) {
    padding-top: 8px;
    padding-bottom: 16px !important;
  }
`;

export const Title = styled.h1`
  color: var(--grey);
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  padding: 0 !important;
  margin: 0 !important;

  @media (max-width: 768px) {
    font-size: 21px;
  }
`;

export const ProgramButtonPrimaryOutlined = styled(Button)`
  display: flex;
  height: 32px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--primary);
  background-color: var(--white);

  color: var(--primary);
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`;

export const ProgramButtonPrimary = styled(Button)`
  display: flex;
  height: 32px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: var(--primary);

  color: var(--white);
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;

  &[disabled] {
    background-color: var(--border) !important;
    border: 1px solid var(--border) !important;
  }
`;

export const ProgramVisualizeButton = styled(Button)`
  display: flex;
  height: 32px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: var(--secondary-p);

  color: var(--primary);
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`;

export const ProgramFormContainer = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--white);
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
  margin-top: 32px !important;

  & label[class="form-label"] {
    color: var(--grey);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
  }

  & input[class="form-control"] {
    display: flex;
    height: 38px;
    padding: 8px;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    color: var(--grey) !important;

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 22.4px */
  }

  @media (max-width: 768px) {
    gap: 16px;

    .program-date-row {
      gap: 16px;
    }

    .program-date-row > [class*="col"] {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .program-video-row {
      gap: 16px;
    }

    .program-video-row > [class*="col"] {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const AddVideoButton = styled(Button)`
  display: flex;
  padding: 0 8px;
  align-items: center;
  gap: 8px;

  color: var(--primary);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;

  background-color: transparent !important;
  border: none !important;

  &:hover,
  &:focus {
    background-color: transparent !important;
    text-decoration: underline !important;
    color: var(--primary) !important;
  }

  &[disabled] {
    color: var(--border) !important;
  }
`;

export const RemoveVideoButton = styled(Button)`
  display: flex;
  padding: 0 8px;
  align-items: center;
  gap: 8px;

  color: var(--primary);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;

  background-color: transparent !important;
  border: none !important;

  padding-left: 12px !important;
  padding-right: 12px !important;

  &:hover,
  &:focus {
    background-color: var(--primary);
  }
`;
export const QuillEditorWrapper = styled.div`
  .ql-container {
    min-height: 150px;
    font-size: 16px;
    border-radius: 0 0 8px 8px;
  }

  .ql-toolbar {
    border-radius: 8px 8px 0 0;
  }

  .ql-editor {
    min-height: 150px;
  }

  .ql-editor p {
    margin: 0;
    padding: 0;
  }

  .ql-editor.ql-blank::before {
    font-style: normal;
    color: #6c757d;
    left: 15px;
    right: 15px;
  }
`;
